module.exports = __webpack_public_path__ + "static/story3-03-800x533-34a36dbf2316d63c40d687c681a6f9f8.jpg";